import Alpine from "alpinejs";

const getLanguageLink = (language) => document.querySelector(`link[rel="alternate"][hreflang="${language}"]`)?.href;
const CURRENT_HREF = window.location.pathname;
const CURRENT_LANGUAGE = document.documentElement.lang?.replace("-", "");
const LANGUAGE_LINKS = {
    deAT: getLanguageLink("de-AT"),
    enGB: getLanguageLink("en-GB"),
};
const HAS_MULTIPLE_LANGUAGES = LANGUAGE_LINKS.deAT && LANGUAGE_LINKS.enGB;

Alpine.data("language", function () {
    const BINDINGS = {
        headline: {
            "x-show": () => HAS_MULTIPLE_LANGUAGES,
        },
        links: {
            "x-show": () => HAS_MULTIPLE_LANGUAGES,
        },
    };
    Object.keys(LANGUAGE_LINKS).forEach((language) => {
        const LINK = LANGUAGE_LINKS[language];
        BINDINGS[language] = HAS_MULTIPLE_LANGUAGES
            ? {
                  ":href": () => LINK,
                  ":class": () => CURRENT_LANGUAGE == language && "font-medium",
              }
            : {};
    });
    return BINDINGS;
});

Alpine.data("footerNavigation", () => ({
    link: (url) => ({ ":class": () => (CURRENT_HREF == url ? "text-gray-900" : "text-gray-500") }),
}));

const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

Alpine.data("newsletter", () => ({
    email: "",
    open: false,
    error: false,
    formRendered: false,
    submit: {
        ":disabled"() {
            return !EMAIL_REGEX.test(this.email);
        },
    },
    modal: {
        "x-show"() {
            return this.open;
        },
        "x-trap.inert.noscroll"() {
            return this.open;
        },
        "x-transition"() {
            return;
        },
    },
    modalBackground: {
        "x-show"() {
            return this.open;
        },
        "x-transition.opacity"() {
            return;
        },
    },
    modalContent: {
        "@click.outside"() {
            this.open = false;
        },
    },
    times: {
        "@click"() {
            this.open = false;
        },
    },
    form: {
        "@submit.prevent"() {
            this.open = true;
        },
    },
}));

Alpine.data("mediaCredits", () => ({
    markup: "",
    open: false,
    loading: false,
    init() {
        this.$watch("open", (value) => {
            if (value && !this.content) {
                this.fetch();
            }
        });
    },
    async fetch() {
        let url = window.location.pathname;
        if (url && url !== "/") {
            url += url.includes("?") ? "&credits=true" : ".credits";
        } else {
            url = "?credits=true";
        }

        this.loading = true;
        await this.$nextTick();
        try {
            const response = await fetch(url);
            if (response.ok) {
                this.markup = await response.text();
            } else {
                console.error("Failed to fetch dialog content:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching dialog content:", error);
        }
        this.loading = false;
    },
    modal: {
        "x-show"() {
            return this.open;
        },
        "x-trap.inert.noscroll"() {
            return this.open;
        },
        "x-transition"() {
            return;
        },
    },
    modalContent: {
        "@click.outside"() {
            this.open = false;
        },
    },
    times: {
        "@click"() {
            this.open = false;
        },
    },
}));
